import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EntriBiExtension = ModuleExtensions.biEventsExtension();
//# sourceMappingURL=entriBiExtension.js.map